import React from "react";
import { Segment, Header } from "semantic-ui-react";
import { Trans, translate } from "react-i18next";
const AboutComponent = ({ t }) => (
  <div>
    <Header as="h1">{t("sidebar:about")}</Header>
    <Segment>
      <Trans i18nKey="message:infoMessageText">
        <div>
          <p>
            <strong>
              Aplikacja HotelCleanApp pozwala zarządzać procesem sprzątania w
              Twoim obiekcie oraz na bieżąco monitorować postępy prac personelu
              sprzątającego.
            </strong>
          </p>

          <p>
            Na stronie głównej widoczne są wszystkie Twoje pokoje. Pokój czysty
            wyświetlany jest w kolorze szarym, pokój brudny w kolorze czerwonym,
            pokój posprzątany w kolorze zielonym, natomiast na pomarańczowo
            zaznaczane są pokoje, w których aktualnie trwa sprzątanie.
          </p>

          <p>
            Jeśli korzystasz z aplikacji niezależnie od programu KWHotel, w
            pierwszym kroku dodaj grupy pokoi, a następnie pokoje (zakładka{" "}
            <strong>Ustawienia >Typy pokoi i Ustawienia > Pokoje</strong>
            ). Jeśli Twoja aplikacja współpracuje z programem KWHotel – baza
            pokoi została już zaimportowana.{" "}
          </p>

          <p>
            Podczas korzystania z aplikacji niezależnie, klikając na wybranym
            pokoju możesz manulanie ustawiać przyjazdy lub wyjazdy w danym dniu.
            Jeśli aplikacja jest połączona z programem KWHotel, dane te będą
            przesyłane automatycznie i nie będzie możliwości ich modyfikowania z
            poziomu aplikacji.
          </p>

          <p>
            W oknie edycji danego pokoju możesz dodawać komentarze – będą one
            wyświetlane pracownikowi, któremu przydzielisz pokój do sprzątania.
          </p>

          <p>
            Strona główna w panelu administratora domyślnie wyświetla stan pokoi
            w bieżącym dniu. W prawym górnym rogu dostępny jest przycisk
            umożliwiający zmianę daty.{" "}
          </p>

          <p>
            Bez względu na wariant korzystania z HotelCleanApp (niezależnie bądź
            w synchronizacji z KWHotel), niezbędne jest dodanie kont pracowników
            (zakładka <strong>Ustawienia > Użytkownicy</strong>
            ).
          </p>

          <p>
            Jeśli posiadasz już bazę pokoi i pracowników – możesz zaplanować
            sprzątanie (zakładka Sprzątanie). Po kliknięciu{" "}
            <strong>Zaplanuj spotkanie</strong> możesz swobodnie planować
            sprzątanie, wybierać daty oraz dodawać pokoje do listy dla danego
            pracownika (metodą przeciągnij i upuść). Kiedy skończysz pracę,
            zapisz zmiany. Zaplanowane sprzątania możesz edytować lub usuwać
            używając opcji znajdujących się po prawej stronie tabeli sprzątań
            (tabela będzie widoczna, jeśli zaplanujesz minimum 1 sprzątanie).
          </p>

          <p>
            W aplikacji mobilnej dla personelu sprzątającego, podstawowy widok
            obejmuje kafelki z zaplanowanymi dla danego pracownika pokojami, a w
            nich wyświetlane są informacje o przyjazdach, wyjazdach oraz
            komentarze. Po wybraniu jednego z pokoi, pracownik ma możliwość
            rozpoczęcia sprzątania – Start cleaning. Po zakończeniu pracy
            powinien nacisnąć klawisz Finish cleaning. W wyjątkowych sytuacjach
            może skorzystać z przycisku Abort cleaning, wtedy pokój pozostanie
            oznaczony jako brudny.
          </p>

          <p>
            <strong>
              Życzymy czystej przyjemności korzystania z aplikacji
              HotelCleanApp!
            </strong>
          </p>
        </div>
      </Trans>
    </Segment>
  </div>
);

export default translate("translations")(AboutComponent);



// WEBPACK FOOTER //
// ./src/components/AboutComponent.js